export const SET_BELASTUNGSFALL_JOINT_NAME = 'SET_BELASTUNGSFALL_JOINT_NAME';
export const SET_BELASTUNGSFALL_ACTIVITY_NAME = 'SET_BELASTUNGSFALL_ACTIVITY_NAME';
export const SET_BELASTUNGSFALL_PARAMETER_NAME = 'SET_BELASTUNGSFALL_PARAMETER_NAME';
export const SET_BELASTUNGSFALL_FILE_NAME = 'SET_BELASTUNGSFALL_FILE_NAME';
export const DELETE_BELASTUNGSFALL_META_DATA = 'DELETE_BELASTUNGSFALL_META_DATA';
